export { useLessonPageStrokeViewSize } from "#use-lesson-page-stroke-view-size";
